/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireSummary
 */
export interface CustomQuestionnaireSummary {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireSummary
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireSummary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireSummary
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireSummary
   */
  readonly createdBy: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireSummary
   */
  readonly updatedBy: string;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireSummary
   */
  readonly createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireSummary
   */
  readonly updatedAt: Date;
}

/**
 * Check if a given object implements the CustomQuestionnaireSummary interface.
 */
export function instanceOfCustomQuestionnaireSummary(value: object): value is CustomQuestionnaireSummary {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireSummaryFromJSON(json: any): CustomQuestionnaireSummary {
  return CustomQuestionnaireSummaryFromJSONTyped(json, false);
}

export function CustomQuestionnaireSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireSummary {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    description: json['description'],
    createdBy: json['created_by'],
    updatedBy: json['updated_by'],
    createdAt: new Date(json['created_at']),
    updatedAt: new Date(json['updated_at']),
  };
}

export function CustomQuestionnaireSummaryToJSON(
  value?: Omit<CustomQuestionnaireSummary, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    description: value['description'],
  };
}
